import axios from "../utils/axios.wrapper";

export const getModels = async () => {
  const { data } = await axios.get("/model");
  return data.items || data;
};

export const getActiveModels = async () => {
  const { data } = await axios.get("/model/active");
  return data.items || data;
};

export const getInactiveModels = async () => {
  const { data } = await axios.get("/model/inactive");
  return data.items || data;
};

export const getModelById = async (id) => {
  const { data } = await axios.get(`/model/${id}`);
  return data;
};

export const getModelByName = async (name) => {
  const { data } = await axios.get(`/model/name/${name}`);
  return data;
};

export const getModelsByBrand = async (brandId) => {
  const { data } = await axios.get(`/model/brand/${brandId}`);
  return data;
};

export const createModel = async (model) => {
  const { data } = await axios.post("/model/create", model);
  return data;
};

export const updateModel = async (id, model) => {
  const { data } = await axios.put(`/model/${id}`, model);
  return data;
};

export const deleteModel = async (id) => {
  const { data } = await axios.delete(`/model/${id}`);
  return data;
};

export const hardDeleteModel = async (id) => {
  const { data } = await axios.delete(`/model/hard/${id}`);
  return data;
};


// --- IMPORT ENDPOINT ---
export const importModels = async (file) => {
  const formData = new FormData();
  formData.append('File', file); // Matches C# FileUploadDto.File
  const { data } = await axios.post("/model/import", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

// --- TEMPLATE DOWNLOAD ---
export const downloadModelTemplate = async () => {
  const response = await axios.get("/model/download-template", {
    responseType: 'blob',
  });
  return response;
};

export const modelService = {
  getModels,
  getActiveModels,
  getInactiveModels,
  getModelById,
  getModelByName,
  getModelsByBrand,
  createModel,
  updateModel,
  deleteModel,
  hardDeleteModel,
  importModels,
  downloadModelTemplate,
};